import { createRoot } from "react-dom/client";
import React, { ComponentType } from "react";
import { Config } from "@kaltura/mediaspace-shared-data-kms-config";
import { TopLevelComponentWrappers } from "@kaltura/mediaspace-shared-layout";

const Login = React.lazy(() => import("@mediaspace/features/login/login/Login"));

const ForgotPassword = React.lazy(() => import("@mediaspace/features/login/forgot-password/ForgotPassword"));

const PasswordExpired = React.lazy(() => import("@mediaspace/features/login/password-expired/PasswordExpired"));
const ResetPassword = React.lazy(() => import("@mediaspace/features/login/reset-password/ResetPassword"));

const SetPassword = React.lazy(() => import("@mediaspace/features/login/set-password/SetPassword"));

const LoginSelection = React.lazy(() => import("@mediaspace/features/login/login-selection/LoginSelection"));

/**
 * this will be used to render other components/pages
 */
const render = (
    containerId: string,
    props: React.ComponentProps<any> & { context: Config; component: ComponentType<any> }
) => {
    const { context, component: Component, ...rest } = props;
    const root = createRoot(document.getElementById(containerId)!);
    root.render(
        <TopLevelComponentWrappers context={context}>
            <Component {...rest} />
        </TopLevelComponentWrappers>
    );
};

export { render, Login, ForgotPassword, PasswordExpired, ResetPassword, SetPassword, LoginSelection };
